import { WppButton, WppEmptyError, WppTypography } from '@wppopen/components-library-react'
import styles from './ErrorBoundaryPage.module.scss'

export default function ErrorBoundaryPage() {
  return (
    <div className={styles.page} data-testid="error-boundary-page">
      <WppEmptyError />
      <WppTypography tag="h1" type="5xl-display" className={styles.heading}>
        Something went wrong
      </WppTypography>
      <WppTypography tag="h1" type="s-body" className={styles.text}>
        Please refresh the page and if the issue persists, try later or contact support.
      </WppTypography>

      <WppButton size="m" variant="primary" onClick={() => window.location.reload()}>
        Reload page
      </WppButton>
    </div>
  )
}
